module.exports = __webpack_public_path__ + "img/integration3.a53a7fd8.png";